var map = {
	"./ULTRAFOMO.png": 12,
	"./bystrina.png": 13,
	"./crypto-alphanumeric-id.png": 14,
	"./dreambounty.png": 15,
	"./jsjot.png": 16,
	"./status.png": 17
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11;